import { SectionColumnConfig } from './section-column-config';

export class PrintCardColumnConfig extends SectionColumnConfig {}
